export const AGENT_SIGNUP_SESSION_KEY = 'AGENT_SIGNUP_SESSION';

export function getAgentSignupSessionId(): number | undefined {
  const sessionValue = sessionStorage.getItem(AGENT_SIGNUP_SESSION_KEY);
  if (!sessionValue) {
    return undefined;
  }

  const parsedValue = parseInt(sessionValue);
  if (isNaN(parsedValue)) {
    return undefined;
  }

  return parsedValue;
}

export function setAgentSignupSessionId(agentId: number): void {
  sessionStorage.setItem(AGENT_SIGNUP_SESSION_KEY, String(agentId));
}
